

export interface IShopContentTokensConfig {
    lang: string;
    tokens:ShopContentTokenConfigItem[];
}

export enum ShopTokenGroup {
    General = "GENERAL",
    Label = "LABEL",
    Button = "BUTTON",
    Error = "ERROR",
    Title = "TITLE",
    Description = "DESCRIPTION",
    Link = "LINK",
    Navigation = "NAVIGATION",
    Help = "HELP",

}


export type ShopTokenParams = {
    [key: string]: "REQUIRED" | "OPTIONAL";
}

export enum ShopTokenFieldType  {
    SingleLineContent = "TEXT",
    MultilineContent = "MULTILINE_TEXT",
    Html = "HTML",
}

export interface ShopTokenMeta {
    type: string;
    value: string;
}

export interface ShopContentTokenConfigItem {
    key: string;
    value: string;
    group: string;
    title: string;
    description: string;
    fieldType: ShopTokenFieldType;
    params?: ShopTokenParams;
    meta: ShopTokenMeta;
    minLength?: number;
    maxLength?: number;
}

export interface IShopContentTokenConfigGroup {
    name: string;
    title: string;
    group: ShopTokenGroup;
    description: string;
}
